import type { FieldPath } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ScrollView, type TextInput } from "react-native";

import { Block, Input, Typography, useBreakpoints } from "@stepapp/ui";

import { useRef } from "react";
import { focusInput } from "../../src/helpers";
import { type RegisterFormValues, useRegisterFormContext } from "./_layout";

export default function RegisterBasicInfoScreen() {
  const lastNameRef = useRef<TextInput>(null);
  const emailRef = useRef<TextInput>(null);
  const { t } = useTranslation();

  const { fullHdHeight } = useBreakpoints();
  const {
    formState: { errors },
    watch,
    setValue,
    trigger,
  } = useRegisterFormContext();

  const values = watch();

  const handleBlur = (fieldName: FieldPath<RegisterFormValues>) => () => trigger(fieldName);

  const handleChange = (fieldName: FieldPath<RegisterFormValues>) => (value: string) => {
    setValue(fieldName, value, {
      shouldTouch: true,
      shouldValidate: true,
    });
  };

  return (
    <ScrollView>
      <Typography variant={fullHdHeight ? "largeTitle" : "title"}>
        {t("pages.auth.registerInStepapp")}
      </Typography>

      <Block paddingTop={fullHdHeight ? 4 : 2}>
        <Typography type="secondary" variant="body">
          {t("pages.auth.basicInfoDescription")}
        </Typography>
      </Block>

      <Block paddingTop={1}>
        <Input
          error={errors?.firstName?.message}
          onBlur={handleBlur("firstName")}
          onChangeText={handleChange("firstName")}
          onSubmitEditing={focusInput(lastNameRef)}
          placeholder={t("components.input.placeholder.firstName")}
          returnKeyType="next"
          value={values.firstName}
        />
        <Input
          error={errors?.lastName?.message}
          onBlur={handleBlur("lastName")}
          onChangeText={handleChange("lastName")}
          onSubmitEditing={focusInput(emailRef)}
          placeholder={t("components.input.placeholder.lastName")}
          ref={lastNameRef}
          returnKeyType="next"
          value={values.lastName}
        />
        <Input
          error={errors?.email?.message}
          keyboardType="email-address"
          onBlur={handleBlur("email")}
          onChangeText={handleChange("email")}
          placeholder={t("components.input.placeholder.email")}
          ref={emailRef}
          value={values.email}
        />
      </Block>
    </ScrollView>
  );
}
